import { useFilePicker } from "use-file-picker";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import SKRActions from "../redux/actions";

import Compressor from "compressorjs";
/*
    Wrapper for useFilePicker.js
*/
const useClickUpload = () => {
  const [openFileSelector, { plainFiles, errors }] = useFilePicker({
    readAs: "ArrayBuffer",
    accept: "image/*",
    multiple: true,
    limitFilesConfig: { max: 20 },
    // minFileSize: 0.1, // in megabytes
    maxFileSize: 50,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (errors.length !== 0 || plainFiles.length === 0) return;
    handleCompressedUpload(plainFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plainFiles]);

  const handleCompressedUpload = (files) => {
    if (files.length === 0) return;

    for (const [k, v] of Object.entries(files)) {
      if (v.type.match(/image.*/)) {
        new Compressor(v, {
          quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
          maxWidth: 2000,
          minWidth: 512,
          success: (compressedResult) => {
            handleFile(compressedResult);
          },
        });
      }
    }
  };
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFile = async (file) => {
    if (!file || !file.type.match(/image.*/)) {
      alert("Please select an image file.");
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file);
    }
    const upload = {
      src: file.url || file.preview,
      x: 300,
      y: 300,
      imageType: "sketch",
      id: uuidv4(),
    };
    dispatch(SKRActions.imageAdded(upload));
    dispatch(SKRActions.sketchSelected(upload));
    dispatch(SKRActions.imageClicked(upload));
  };

  return [openFileSelector];
};

export default useClickUpload;
